export default {
    smsSent: 'Ваше SMS успешно отправлено. Если SMS не пришло, вы можете повторно отправить SMS через {n} секунд.',
    buttons: {
        save: 'Сохранить',
        resend: 'Отправить SMS еще раз',
    },
    fields: {
        token: {
            label: 'Введите код подтверждения из SMS',
            placeholder: '******',
        },
    },
    errors: {
        user_invalid_change_mobile_token: 'Неверный код подтверждения!',
    },
}
